import { useState } from "react";
import FaiBox from "MuiComponents/FaiBox";
import FaiTypography from "MuiComponents/FaiTypography";
import theme from "assets/theme";
import { Form, Formik, FormikProps } from "formik";
import { Grid } from "@mui/material";
import FormField from "components/FormField";
import FaiButton from "MuiComponents/FaiButton";
import FaiDropzone from "MuiComponents/FaiDropzone";
import FaiSelect from "MuiComponents/FaiSelect";
import Axios from "services/api/config";
import { setBrandInfo } from "services/api/routes/Auth";
import PageHeader from "../components/PageHeader";

interface InitialObject {
	brandName: string;
	brandWebsite: string;
	category: string;
	numberOfProducts: string;
	sellOnOtherPlatforms: string;
	logo: string;
	selfDeclaration: boolean;
	termsAndCOnditionAggrement: boolean;
}

const initialBrand = {
	brandName: "Brand",
};

function BrandDetails({ onNextStep = () => {} }) {
	const { palette } = theme;
	const [brands, setBrands] = useState([initialBrand]);

	const [initialObject] = useState<InitialObject>({
		brandName: "",
		brandWebsite: "",
		category: "",
		numberOfProducts: "",
		sellOnOtherPlatforms: "",
		logo: "",
		selfDeclaration: false,
		termsAndCOnditionAggrement: false,
	});

	const [isLoading, setLoading] = useState(false);

	const onSubmit = async (data: object) => {
		try {
			setLoading(true);
			const { data } = await Axios({
				...setBrandInfo,
				data: {},
			});
			console.log("data", data);
			// You can trigger the next step here if necessary
			onNextStep();
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<FaiBox
				bgColor={palette.white.main}
				className={"business-details px-5 py-4 rounded-b-lg"}
			>
				<PageHeader
					title="Brand Details"
					content="Please provide the details of the brands your company owns and
							wants to sell on our platform."
				/>

				<FaiBox className="flex items-center gap-3 mb-5">
					<FaiBox className="flex gap-3">
						{brands.map((brand) => (
							<FaiButton color="dark">{brand.brandName}</FaiButton>
						))}
					</FaiBox>
					<FaiBox
						className="flex items-center cursor-pointer"
						onClick={() => setBrands((prev) => [...prev, initialBrand])}
					>
						<FaiBox
							component="span"
							className="flex items-center"
							sx={{
								justifyContent: "center",
								border: "2px solid #E97A36",
								borderRadius: "50%",
								width: "24px",
								height: "24px",
								marginRight: "8px",
								color: "#E97A36",
							}}
						>
							+
						</FaiBox>
						<FaiBox
							component="span"
							sx={{
								color: "#E97A36",
								fontSize: "14px",
								fontWeight: "500",
								textTransform: "none",
							}}
						>
							Add Brand
						</FaiBox>
					</FaiBox>
				</FaiBox>

				<Formik
					initialValues={initialObject}
					enableReinitialize={true}
					validateOnBlur={true}
					validateOnChange={true}
					onSubmit={onSubmit}
				>
					{(props: FormikProps<InitialObject>) => {
						const {
							// handleSubmit,
							// setFieldValue,
							handleChange,
							handleBlur,
							values,
							touched,
							// isValid,
							errors,
						} = props;
						return (
							<Form className="py-4">
								<Grid container spacing={2}>
									<Grid item xs={12} sm={6}>
										<FaiBox xs={12} sm={6}>
											<FormField
												label={"Brand Name"}
												name={"brandName"}
												placeholder={"Enter Brand Name"}
												value={values.brandName}
												onChange={handleChange}
												onBlur={handleBlur}
												error={touched.brandName && Boolean(errors.brandName)}
												helperText={touched.brandName && errors.brandName}
												autoFocus
												isRequired
											/>
										</FaiBox>
									</Grid>
									<Grid item xs={12} sm={6}>
										<FaiBox xs={12} sm={6}>
											<FormField
												label={"Brand Website"}
												name={"brandWebsite"}
												placeholder={"Enter Link"}
												value={values.brandWebsite}
												onChange={handleChange}
												onBlur={handleBlur}
												error={
													touched.brandWebsite && Boolean(errors.brandWebsite)
												}
												helperText={touched.brandWebsite && errors.brandWebsite}
												isRequired
											/>
										</FaiBox>
									</Grid>

									<Grid item sm={12} xs={12}>
										<FaiBox mb={1}>
											<FormField
												multiline
												rows={5}
												label={"Brand Description"}
												name={"brandDescription"}
												placeholder={"Enter Brand Description"}
												isRequired
											/>
										</FaiBox>
									</Grid>

									<Grid item xs={12} sm={6}>
										<FaiBox
											mb={1}
											className="!text-base leading-6 !font-medium"
											display="inline-block"
										>
											<FaiTypography
												component="label"
												variant="caption"
												className="!text-base leading-6 !font-medium"
												textTransform="capitalize"
												isRequired
											>
												Product Categories
											</FaiTypography>
										</FaiBox>
										<FaiSelect
											placeholder={"Category"}
											defaultValue={{ value: "clothing", label: "Clothing" }}
											name={"category"}
											options={[
												{ value: "clothing", label: "Clothing" },
												{ value: "electronics", label: "Electronics" },
												{ value: "furniture", label: "Furniture" },
												{ value: "others", label: "Others" },
												{ value: "real estate", label: "Real Estate" },
											]}
										/>
									</Grid>

									{/* <Grid item xs={12} sm={6}>
										<FaiBox xs={12} sm={6}>
											<FormField
												label={"No. of Products"}
												name={"numberOfProducts"}
												placeholder={"No. of Products"}
												value={values.brandName}
												onChange={handleChange}
												onBlur={handleBlur}
												error={
													touched.numberOfProducts &&
													Boolean(errors.numberOfProducts)
												}
												helperText={
													touched.numberOfProducts && errors.numberOfProducts
												}
											/>
										</FaiBox>
									</Grid> */}

									<Grid item xs={12} sm={6}>
										<FaiBox
											mb={1}
											className="!text-base leading-6 !font-medium"
											display="inline-block"
										>
											<FaiTypography
												component="label"
												variant="caption"
												className="!text-base leading-6 !font-medium"
												textTransform="capitalize"
												isRequired
											>
												Do you sell on other platforms?
											</FaiTypography>
										</FaiBox>
										<FaiSelect
											placeholder={"Select platforms"}
											// defaultValue={{ value: "clothing", label: "Clothing" }}
											name={"sellOnOtherPlatforms"}
											options={[
												{ value: "clothing", label: "Clothing" },
												{ value: "electronics", label: "Electronics" },
												{ value: "furniture", label: "Furniture" },
												{ value: "others", label: "Others" },
												{ value: "real estate", label: "Real Estate" },
											]}
										/>
									</Grid>
									<Grid item xs={12} sm={6}>
										<FaiBox mb={1} display="inline-block">
											<FaiTypography
												component="label"
												variant="caption"
												className="!text-base leading-6 !font-medium"
												textTransform="capitalize"
												isRequired
											>
												States you ship to
											</FaiTypography>
										</FaiBox>
										<FaiSelect
											placeholder={"Select platforms"}
											// defaultValue={{ value: "clothing", label: "Clothing" }}
											name={"sellOnOtherPlatforms"}
											options={[
												{ value: "clothing", label: "Clothing" },
												{ value: "electronics", label: "Electronics" },
												{ value: "furniture", label: "Furniture" },
												{ value: "others", label: "Others" },
												{ value: "real estate", label: "Real Estate" },
											]}
										/>
									</Grid>

									<Grid item sm={12} xs={12}>
										<FaiBox mb={1}>
											<FaiBox my={1} display="inline-block w-full">
												<FaiTypography
													component="label"
													variant="caption"
													className="!text-base leading-6 !font-medium"
													textTransform="capitalize"
													note="Notes for brand logo"
													isRequired
												>
													Brand Logo
												</FaiTypography>
											</FaiBox>
											<FaiDropzone
												options={{
													addRemoveLinks: true,
													uploadMultiple: false,
													maxFiles: 1,
												}}
											/>
										</FaiBox>
									</Grid>
								</Grid>
								{/* <FormControlLabel
									control={
										<Checkbox
											checked={values.selfDeclaration}
											onChange={handleChange}
											name="gilad"
										/>
									}
									label={
										<FaiTypography
											component="label"
											variant="caption"
											textTransform="capitalize"
										>
											I hereby declare that all the details submitted are true.
										</FaiTypography>
									}
								/>
								<FormControlLabel
									control={
										<Checkbox
											checked={values.termsAndCOnditionAggrement}
											onChange={handleChange}
											name="gilad"
										/>
									}
									label={
										<FaiTypography
											component="label"
											variant="caption"
											textTransform="capitalize"
										>
											I accept all the terms and conditions.
										</FaiTypography>
									}
								/> */}

								<FaiBox pt={"15px"}>
									<Grid container className="flex justify-end gap-5">
										<FaiButton
											color="primary"
											variant={"contained"}
											disabled={isLoading}
										>
											Save
										</FaiButton>
										<FaiButton variant={"outlined"} onClick={onNextStep}>
											Save & Continue
										</FaiButton>
									</Grid>
								</FaiBox>
							</Form>
						);
					}}
				</Formik>
			</FaiBox>
		</>
	);
}

export default BrandDetails;
